module.exports = __webpack_public_path__ + "static/media/homeImg.fee16a18.png";